<template>
  <div>
    <v-dialog v-model="mallManagerInfoDialog" max-width="300">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-3 d-block"
          ><p class="mb-0 text-start" style="font-weight: 600;">
            쇼핑몰 담당자 정보를
          </p>
          <p class="mb-0 text-start" style="font-weight: 600;">
            입력해주세요.
          </p></v-card-title
        >

        <v-card-text class="pl-5 d-block pb-1">
          <p class="mb-0 text-start">
            앱 사용 기간 만료등 안내에 필요합니다.
          </p>
          <p class="mb-0 text-start">
            연락 가능한 정보를 입력하시면 편리하게
          </p>
          <p class="mb-0 text-start">
            사용이 가능합니다.😊😀
          </p>
        </v-card-text>

        <v-col class="pb-0">
          <v-text-field
            v-model="ordersPayload.mall_name"
            label="쇼핑몰명"
            single-line
            outlined
            dense
            autocomplete="off"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="ordersPayload.mall_manager"
            label="담당자명"
            single-line
            outlined
            dense
            autocomplete="off"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="ordersPayload.mall_phone"
            label="핸드폰번호"
            single-line
            outlined
            dense
            autocomplete="off"
            @keydown="M.checkNumber($event)"
            @keypress="M.replaceNumber($event, 12, false)"
            @blur="M.replaceNumber($event, 12, false)"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="ordersPayload.mall_email"
            label="이메일주소"
            single-line
            outlined
            dense
            autocomplete="off"
            hide-details
          ></v-text-field>
        </v-col>

        <div class="mt-5 pb-5">
          <v-btn
            style="background-color: rgb(127, 127, 127); border-color: rgb(127, 127, 127);"
            hide-details
            depressed
            class="white--text ml-3"
            @click="close()"
            width="134"
            >닫기</v-btn
          >

          <v-btn color="primary" hide-details class="white--text ml-2 pl-4" depressed @click="save()" width="134">저장</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <Alert ref="Alert"></Alert>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Alert from "@/components/common/Alert.vue";
import { setMallManagerInfoHideCookie, shouldHideMallManagerInfo } from "@/utils/cookieUtils";

export default {
  data: () => {
    return {
      M,
      mallManagerInfoDialog: false,
      ordersPayload: {
        mall_name: null,
        mall_manager: null,
        mall_phone: null,
        mall_email: null,
      },
    };
  },
  computed: {
    appCode() {
      // store에서 appCode 값을 가져옴 (없으면 cert_product가 기본값)
      return this.$store.state.appCode || "cert_product";
    },
  },

  methods: {
    close: function() {
      // 15일 동안 모달을 숨기는 쿠키 설정
      const shopNo = this.$store.state.shopNo;
      const mallId = this.$store.state.mallId;
      const appCode = this.$store.state.appCode || "cert_product";

      if (appCode === "cert_digital") {
        // 디지털 상품 인증 서비스인 경우 쿠키 설정
        if (shopNo && mallId && appCode) {
          setMallManagerInfoHideCookie(shopNo, mallId, appCode);
        }
      }

      this.mallManagerInfoDialog = false;
    },
    show: async function(info = null) {
      // 쿠키 확인 - 15일 동안 숨김 상태인지 체크
      const shopNo = this.$store.state.shopNo;
      const mallId = this.$store.state.mallId;
      const appCode = this.$store.state.appCode || "cert_product";

      if (appCode === "cert_digital") {
        if (shopNo && mallId && appCode && shouldHideMallManagerInfo(shopNo, mallId, appCode)) {
          // 쿠키가 있고 아직 만료되지 않았다면 모달을 표시하지 않음
          return;
        }
      }

      if (info) {
        this.ordersPayload = info;
      }
      this.mallManagerInfoDialog = true;
    },
    save: async function() {
      if (!this.ordersPayload.mall_name) {
        this.alertShow("쇼핑몰명을 입력해 주세요.");
        return false;
      }
      if (!this.ordersPayload.mall_manager) {
        this.alertShow("담당자명을 입력해 주세요.");
        return false;
      }
      if (!this.ordersPayload.mall_phone) {
        this.alertShow("핸드폰 번호를 입력해주세요.");
        return false;
      }
      if (!this.ordersPayload.mall_email) {
        this.alertShow("이메일 주소를 입력해주세요. ");
        return false;
      }
      let phone_number_check_result = M.isPhoneNumber(this.ordersPayload.mall_phone);
      if (!phone_number_check_result || this.ordersPayload.mall_phone.length >= 12) {
        this.alertShow("핸드폰 번호가 올바르지 않습니다.");
        return false;
      }

      let mail_check_result = M.isMail(this.ordersPayload.mall_email);
      if (!mail_check_result) {
        this.alertShow("이메일 주소가 올바르지 않습니다.");
        return false;
      }

      // API 전송
      try {
        let data = await M.api(M.entry("/post/orders/latest"), this.ordersPayload);
        if (data) {
          this.alertShow("저장되었습니다.");
          this.mallManagerInfoDialog = false;
        }
      } catch (e) {
        this.alertShow("저장 실패 했습니다.");
      }
    },
  },
  mixins: [CommonMixin],
  components: {
    Alert,
  },
};
</script>
